import styled from 'styled-components';
import { theme } from 'theme/MainTheme';

const Breadcrumbs = styled.p`
  font-size: ${theme.fontSize.xxs};
  color: ${theme.primary};
  font-weight: ${theme.bold};
  span {
    font-weight: ${theme.bold};
  }
  @media (max-width: 740px) {
    font-size: ${theme.fontSize.xxxs};
  }
`;

export default Breadcrumbs;
